import {
  GET_LOCALMACHINEINFO_START,
  GET_LOCALSOFT_START,
  REQUEST_NATIVE_INSTALL,
  REQUEST_NATIVE_INSTALL_LIST,
  REQUEST_NATIVE_UNINSTALL,
  REQUEST_NATIVE_UPGRADE,
  GET_OTHER_INFO,
  SET_OTHER_INFO,
  SET_QUIET_INSRALL_PATH,
  SET_COMMAND_LINE,
  SET_WELCOME_IDS,
  DELETE_WELCOME_IDS,
  GET_THROTTLE_LOCALSOFT_START,
  REMOVE_UNINSTALL_SOFT,
  SILENT_SOFT_INSTALL_INFOS_START,
  SET_UPDATE_NOTIFY_STATUS,
  SET_RESIDUAL_NOTIFY_STATUS,
  SET_RARELY_NOTIFY_STATUS,
  SET_UNINSTALL_FINISH_SOFTS,
  PAYGAME_PAY_LIST_REQUEST,
  GET_SUBSCRIBED_APP_LIST,
  EMPTY_SUBSCRIBED_APP_LIST,
} from '../constants/native';

export const getLocalMachineInfo = () => ({
  type: GET_LOCALMACHINEINFO_START,
});

export const getLocalSoft = () => ({
  type: GET_LOCALSOFT_START,
});

export const getThrottleLocalSoft = () => ({
  type: GET_THROTTLE_LOCALSOFT_START,
});

export const uninstallSoft = soft => ({
  type: REQUEST_NATIVE_UNINSTALL,
  soft,
});

export const getUpgradeSofts = upgradeSofts => ({
  type: REQUEST_NATIVE_UPGRADE,
  upgradeSofts,
});

export const setQuietInstallPath = param => ({
  type: SET_QUIET_INSRALL_PATH,
  ...param,
});

export const getOtherInfo = otherInfo => ({
  type: GET_OTHER_INFO,
  otherInfo,
});

export const setOtherInfo = otherInfo => ({
  type: SET_OTHER_INFO,
  otherInfo,
});

export const setCommandLine = commandLine => ({
  type: SET_COMMAND_LINE,
  commandLine,
});

export const setWelcomeSoftID = ids => ({
  type: SET_WELCOME_IDS,
  ids,
});

export const deleteWelcomeIDS = ids => ({
  type: DELETE_WELCOME_IDS,
  ids,
});

export const removeUninstall = result => ({
  type: REMOVE_UNINSTALL_SOFT,
  result,
});

// 获取支持静默安装的应用
export const getSilentInstallSoft = () => ({
  type: SILENT_SOFT_INSTALL_INFOS_START,
});

//  更改升级弹窗开关
export const setUpdateNotifyStatus = params => ({
  type: SET_UPDATE_NOTIFY_STATUS,
  payload: params,
});

// 更改残留通知开关
export const setResidualNotifyStatus = params => ({
  type: SET_RESIDUAL_NOTIFY_STATUS,
  payload: params,
});

// 更改不常用软件通知开关
export const setRarelyNotifyStatus = params => ({
  type: SET_RARELY_NOTIFY_STATUS,
  payload: params,
});

// 得知具体是哪个应用卸载完成
export const setUninstallFinishSofts = params => ({
  type: SET_UNINSTALL_FINISH_SOFTS,
  payload: params,
});

// 单机付费软件  获取已购买列表 8.4
export const getPayGamePayList = param => ({
  type: PAYGAME_PAY_LIST_REQUEST,
  param,
});

// 获取预约过的应用列表
export const getSubscribedAppList = payload => ({
  type: GET_SUBSCRIBED_APP_LIST,
  payload,
});

// 清空预约过的应用
export const emptySubscribedAppList = payload => ({
  type: EMPTY_SUBSCRIBED_APP_LIST,
  payload,
});
